function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13297",
  width: 36.305,
  height: 36.305,
  fill: "#fffefe"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_69067",
  transform: "translate(-1329 -651)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_68815",
  transform: "translate(0 -12)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Overly",
  d: "M20,0h92a0,0,0,0,1,0,0V40a0,0,0,0,1,0,0H20A20,20,0,0,1,0,20v0A20,20,0,0,1,20,0Z",
  transform: "translate(1329 663)",
  fill: "#7e27e4",
  opacity: 0.9
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_68813",
  transform: "translate(1336.193 664.848)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_148340",
  d: "M18.205,25.318v-5.88l5.037,2.906a2.189,2.189,0,0,0,1.083.4c.456,0,.809-.319,1.265-1.014l.171-.285a2.141,2.141,0,0,0,.422-1.117c0-.5-.365-.866-1.048-1.254l-5.242-3.008,5.231-2.86c.684-.376,1.014-.741,1.014-1.231a2.418,2.418,0,0,0-.387-1.117l-.182-.308c-.41-.707-.775-1.026-1.254-1.026a2.272,2.272,0,0,0-1.083.387l-5.026,2.917.011-5.846c0-1.333-.467-1.687-1.8-1.687h-.331c-1.345,0-1.8.353-1.8,1.687l.011,5.846L9.271,9.911A2.392,2.392,0,0,0,8.12,9.5c-.479,0-.877.308-1.231,1.048l-.16.285a2.9,2.9,0,0,0-.342,1.14c0,.5.319.843,1,1.242L12.6,16.065,7.368,19.074c-.672.387-1.014.741-1.014,1.219a2.349,2.349,0,0,0,.41,1.151l.16.273c.4.707.775,1.037,1.254,1.037a2.35,2.35,0,0,0,1.083-.4L14.3,19.438l-.011,5.88c0,1.333.456,1.687,1.8,1.687h.331C17.749,27.005,18.217,26.652,18.205,25.318Z",
  transform: "translate(1.884 1.571)",
  fill: "#fffefe"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_148541",
  d: "M50,4H0A4,4,0,0,1-4,0,4,4,0,0,1,0-4H50a4,4,0,0,1,4,4A4,4,0,0,1,50,4Z",
  transform: "translate(1378.5 683.5)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_68814",
  transform: "translate(0 -12)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Overly-2",
  d: "M20,0H92a0,0,0,0,1,0,0V40a0,0,0,0,1,0,0H20A20,20,0,0,1,0,20v0A20,20,0,0,1,20,0Z",
  transform: "translate(1349 709)",
  fill: "#000026",
  opacity: 0.12
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_1365",
  d: "M50,4H0A4,4,0,0,1-4,0,4,4,0,0,1,0-4H50a4,4,0,0,1,4,4A4,4,0,0,1,50,4Z",
  transform: "translate(1378.5 729)",
  fill: "#fff"
})));

function SvgRequiredNotificationTipBackgroundBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 112 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequiredNotificationTipBackgroundBanner);
export default __webpack_public_path__ + "static/media/required-notification-tip-background-banner.8e3a632b.svg";
export { ForwardRef as ReactComponent };